import { render, staticRenderFns } from "./QuantidadesCompra.vue?vue&type=template&id=5a0f7dfa"
import script from "./QuantidadesCompra.vue?vue&type=script&lang=js"
export * from "./QuantidadesCompra.vue?vue&type=script&lang=js"
import style0 from "./QuantidadesCompra.vue?vue&type=style&index=0&id=5a0f7dfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports